import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import SelectInput from '../../inputs/SelectInput';

import { BlueCloseIcon } from '../../../images/icons/WrapSvg';

class MachineEditPopup extends React.Component {

    state = {
        open: true,
        id: { label: this.props.tiposmaquina.find(f => f.id.toString() === this.props.machine.idTipomaquina.toString()).nombre.toUpperCase(), value: this.props.machine.idTipomaquina },
        nombre: this.props.machine.nombre
    };

    handleChangeMachine = (event) => {
        console.log(event.value);
        this.setState({ id: event });
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleSummit = () => {
        const { id, nombre } = this.state;
        this.props.handleClose(id.value, nombre);
    };

    render() {
        const { id, nombre, open } = this.state;
        const { tiposmaquina, handleClose, intl } = this.props;
        return (
            <Dialog
                onClose={() => handleClose(false)}
                aria-labelledby="customized-dialog-title"
                open={open}
                disableBackdropClick
                classes={{
                    paper: 'xhef_command_popup',
                }}
            >
                <div className="flex_full_column">
                    <div className="flex_auto_row xhef_waste_popup_header align_center">
                        <IconButton
                            aria-label="Close"
                            className={''}
                            onClick={() => handleClose(false)}
                        >
                            <BlueCloseIcon />
                        </IconButton>
                        <div className="flex_full_row center barlowsemicondensed_bold">
                            <FormattedMessage id="xhef_popup_command_change_title" />
                        </div>
                    </div>
                    <div className="flex_auto_row">
                        <div className="flex_full_column padding_borders">
                            <TextField
                                fullWidth
                                id={'nombre'}
                                name={'nombre'}
                                required
                                label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                                className={'flex_full_row'}
                                value={nombre}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                            <div className="flex_auto_row align_center margin_top_12">
                                {tiposmaquina &&
                                    <SelectInput
                                        defaultValue={id}
                                        placeHolder={intl.formatMessage({
                                            id: 'form_field_name_tipo',
                                        })}
                                        isNotSearchable
                                        options={
                                            tiposmaquina
                                                .sort((a, b) =>
                                                    a.nombre.toUpperCase() < b.nombre.toUpperCase()
                                                        ? -1
                                                        : 1,
                                                )
                                                .map((p) => {
                                                    return { label: p.nombre.toUpperCase(), value: p.id.toString() };
                                                })}
                                        onChange={this.handleChangeMachine}
                                    />
                                }

                            </div>
                        </div>
                    </div>
                    <div className="flex_auto_row center xhef_waste_popup_footer">
                        <Button
                            disabled={!id}
                            variant="contained"
                            color="primary"
                            className={'flex_full_row barlow_semibold padding_borders'}
                            onClick={this.handleSummit}
                        >
                            <FormattedMessage id="xhef_popup_command_button_change_type" />
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }
}

MachineEditPopup.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(MachineEditPopup);



// WEBPACK FOOTER //
// ./src/components/complex/xhef/MachineEditPopup.js